import React, {useLayoutEffect, useState} from 'react';
import {AllowCamera, FaceCamera} from '../../components';

import {FullscreenLoading} from 'presentation/components/Loading/FullscreenLoading';
import {translations} from 'presentation/translations-new';

const {loading} = translations['pt-br'].commons;

export function FacePhoto() {
	const [cameraStatus, setCameraStatus] = useState<'checking' | 'granted' | 'denied'>('checking');

	const checkCameraPermission = async () => {
		if (!navigator.permissions) {
			setCameraStatus('denied');
			return;
		}

		try {
			setCameraStatus('checking');
			const result = await navigator.permissions.query({name: 'camera' as PermissionName});
			if (result.state === 'granted' || result.state === 'denied') {
				setCameraStatus(result.state);
			} else {
				setCameraStatus('denied');
			}
		} catch {
			setCameraStatus('denied');
		}
	};

	useLayoutEffect(() => {
		checkCameraPermission();
	}, []);

	if (cameraStatus === 'checking') {
		return <FullscreenLoading text={loading} />;
	}

	return cameraStatus === 'granted' ? (
		<FaceCamera />
	) : (
		<AllowCamera onAllowCameraAccess={checkCameraPermission} />
	);
}
